import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { theme } from "../../utils/theme";
import { MainContainer } from "../../components/MainContainerComp";
import { inputStyle, messageStyle } from "./styled";

interface IContactEmailProps {
  submitting: boolean;
  email: string;
  error: boolean;
  onChangeEmail: (email: string) => void;
  onSubmit: (email: string) => void;
}

export const ContactEmail: React.FC<IContactEmailProps> = ({
  submitting,
  email,
  error,
  onChangeEmail,
  onSubmit,
}) => {
  return (
    <MainContainer>
      <Grid container sx={{ justifyContent: 'center' }} spacing={2}>
        <Grid item md={6} xs={12}>
          <Box sx={{ mt: 5, mb: 5 }}>
            <Typography sx={{ fontWeight: 'bold', mb: 1.5 }}>Email</Typography>
            <TextField
              sx={inputStyle}
              fullWidth
              value={email}
              onChange={e => onChangeEmail(e.target.value)}
              placeholder="Enter your email"
              inputProps={{
                maxLength: 100,
                autoCapitalize: 'none',
              }}
            />
          </Box>
          {<Box sx={{mt: -4, mb: 4, ml: 0.5, mr: 1, color: theme.palette.corporateBlue, display: "flex"}}>
              <InfoIcon sx={{fontSize: "20px"}} />
              <Typography
                component="span"
                sx={{ml: 1, fontSize: "12px"}}
              >
              BCMEA collects your email for the purpose of user verification for your MyBCMEA account 
              and to communicate with you in connection with your employment.
              </Typography>
          </Box>}
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 5 }}>
            <Button
              disabled={submitting}
              size="large"
              variant="contained"
              onClick={() => onSubmit(email)}
              data-automation="submit-btn"
            >
              Submit
            </Button>
          </Box>
          {error &&
            <Paper square elevation={0} sx={messageStyle}>
              <Typography sx={{ mb: 2 }}>
                The email address you entered seems invalid. Please check and try again.
              </Typography>
              <Typography>
                If you're still running into issues, please contact MYBCMEA password reset line at 604-251-6141.
              </Typography>
            </Paper>
          }
        </Grid>
      </Grid>
    </MainContainer>
  )
}

